import React, { Component } from 'react'
import './preview.css'
import { inject, observer } from 'mobx-react'
import { widgetIconLayout } from '../../constant'

@inject('WidgetStore')
@observer
class Preview extends Component {

  icon = () => {
    let url = ''
    const { material_id, font_color } = this.props.WidgetStore.payload
    console.log(material_id)
    switch (material_id) {
      case 1:
        url = `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath fill='${encodeURIComponent(font_color)}' d='m5,16l-2,-11l5.5,5l3.5,-6l3.5,6l5.5,-5l-2,11l-14,0m14,3c0,0.6 -0.4,1 -1,1l-12,0c-0.6,0 -1,-0.4 -1,-1l0,-1l14,0l0,1z'/%3E%3C/g%3E%3C/svg%3E")`
        break
      case 2:
        url = `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath fill='${encodeURIComponent(font_color)}' d='m22,12l0,8a2,2 0 0 1 -2,2l-16,0a2,2 0 0 1 -2,-2l0,-8a1,1 0 0 1 -1,-1l0,-3a2,2 0 0 1 2,-2l3.17,0c-0.11,-0.31 -0.17,-0.65 -0.17,-1a3,3 0 0 1 3,-3c1,0 1.88,0.5 2.43,1.24l0,-0.01l0.57,0.77l0.57,-0.77l0,0.01c0.55,-0.74 1.43,-1.24 2.43,-1.24a3,3 0 0 1 3,3c0,0.35 -0.06,0.69 -0.17,1l3.17,0a2,2 0 0 1 2,2l0,3a1,1 0 0 1 -1,1m-18,8l7,0l0,-8l-7,0l0,8m16,0l0,-8l-7,0l0,8l7,0m-11,-16a1,1 0 0 0 -1,1a1,1 0 0 0 1,1a1,1 0 0 0 1,-1a1,1 0 0 0 -1,-1m6,0a1,1 0 0 0 -1,1a1,1 0 0 0 1,1a1,1 0 0 0 1,-1a1,1 0 0 0 -1,-1m-12,4l0,2l8,0l0,-2l-8,0m10,0l0,2l8,0l0,-2l-8,0z'/%3E%3C/g%3E%3C/svg%3E")`
        break
      case 3:
        url = `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath fill='${encodeURIComponent(font_color)}' d='m13.5,20c-6.6,-6.1 -10,-9.2 -10,-12.9c0,-3.1 2.4,-5.5 5.5,-5.5c1.7,0 3.4,0.8 4.5,2.1c1.1,-1.3 2.8,-2.1 4.5,-2.1c3.1,0 5.5,2.4 5.5,5.5c0,3.8 -3.4,6.9 -10,12.9m-1.5,1.1c-6.6,-5.9 -10.5,-9.4 -10.5,-14.1c0,-0.2 0,-0.4 0,-0.6c-0.6,0.9 -1,2 -1,3.2c0,3.8 3.4,6.9 10,12.8l1.5,-1.3z'/%3E%3C/g%3E%3C/svg%3E")`
        break
      case 4:
        url = `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath fill='${encodeURIComponent(font_color)}' d='m12,17.27l6.18,3.73l-1.64,-7.03l5.46,-4.73l-7.19,-0.62l-2.81,-6.62l-2.81,6.62l-7.19,0.62l5.45,4.73l-1.63,7.03l6.18,-3.73z'/%3E%3C/g%3E%3C/svg%3E")`
        break
      case 5:
        url = `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cpath fill='${encodeURIComponent(font_color)}' d='m21.41,11.58l-9,-9c-0.36,-0.36 -0.86,-0.58 -1.41,-0.58l-7,0a2,2 0 0 0 -2,2l0,7c0,0.55 0.22,1.05 0.59,1.42l9,9c0.36,0.36 0.86,0.58 1.41,0.58c0.55,0 1.05,-0.22 1.41,-0.59l7,-7c0.37,-0.36 0.59,-0.86 0.59,-1.41c0,-0.55 -0.23,-1.06 -0.59,-1.42m-15.91,-4.58a1.5,1.5 0 0 1 -1.5,-1.5a1.5,1.5 0 0 1 1.5,-1.5a1.5,1.5 0 0 1 1.5,1.5a1.5,1.5 0 0 1 -1.5,1.5m11.77,8.27l-4.27,4.27l-4.27,-4.27c-0.45,-0.46 -0.73,-1.08 -0.73,-1.77a2.5,2.5 0 0 1 2.5,-2.5c0.69,0 1.32,0.28 1.77,0.74l0.73,0.72l0.73,-0.73c0.45,-0.45 1.08,-0.73 1.77,-0.73a2.5,2.5 0 0 1 2.5,2.5c0,0.69 -0.28,1.32 -0.73,1.77z'/%3E%3C/g%3E%3C/svg%3E")`
        break
    }
    return (
      <div className="shopahetti-pop-icon" style={{backgroundImage: url}} />
    )
    
  }

  button = () => {
    const { launcher_desktop_layout, launcher_content } = this.props.WidgetStore.payload
    switch (launcher_desktop_layout) {
      case widgetIconLayout.icon:
        return (
          <>
            {this.icon()}
          </>
        )
      case widgetIconLayout.text:
        return (
          <>
            <div className="shopahetti-pop-text">{launcher_content}</div>
          </>
        )
      case widgetIconLayout.iconWithText:
        return (
          <>
            {this.icon()}
            <div style={{width: '12px'}} />
            <div className="shopahetti-pop-text">{launcher_content}</div>
          </>
        )
    }
  }

  buttonStyle() {
	const { theme_color, font_color, position } = this.props.WidgetStore.payload
	return {
		color: font_color,
		backgroundColor: theme_color,
		[position == 'bottom_left' ? 'marginRight' : 'marginLeft']: 'auto',
	}
  }

  render() {
    const { theme_color, font_color, program_name } = this.props.WidgetStore.payload

    return (
			<div className='widget-container'>
				<div className='main-container'>
		      <div className="background" data-v-0a41285e="" data-v-7ba5bd90="" data-v-5e5ab372-s=""
		        style={{backgroundImage: `linear-gradient(${theme_color}, ${theme_color} 12%, white)`}}></div>
		      
					<div className="home-container" data-v-fae5bece="" data-v-5e5ab372-s="" style={{paddingBottom: '52px'}}>
					<div className="header-warp" data-v-61dd7a3d="" data-v-7ba5bd90="" data-v-5e5ab372-s="">
		        <div className="header" data-v-61dd7a3d="" style={{color: font_color}}>
		          <div className="top" data-v-61dd7a3d="">
		            <div className="tit" data-v-61dd7a3d="" style={{opacity: 1, bottom: '0px'}}> Welcome to</div>
		            <div className="info" data-v-61dd7a3d="" style={{opacity: 1, bottom: '0px'}}>{program_name}</div>
		          </div>
		        </div>
		        <div className="panel-header-container" data-v-61dd7a3d="">
		          <div className="panel-fixed-header" data-v-61dd7a3d="">
		            <div className="header-flex align-items-center" data-v-61dd7a3d="">
		              <div className="ml-2 header-flex-back" data-v-61dd7a3d=""><i className="back iconfont iconleft-arrow-2"
		                  data-v-61dd7a3d="" style={{color: 'rgb(255, 255, 255)', display: 'none'}}></i></div>
		            </div><button className="iconfont iconclose panel-header-icon" aria-label="Close" data-v-61dd7a3d=""
		              style={{color: 'rgb(255, 255, 255)'}}></button>
		          </div>
		        </div>
		      </div>
		        <div className="card-item-container register" data-v-1aa5f304="" data-v-fae5bece="" style={{marginTop: '20px'}}>
		          <div className="container-title" data-v-1aa5f304="">Become a member</div>
		          <div className="container-list" data-v-1aa5f304="">
		            <div className="container-center" data-v-1aa5f304="">
		              <div className="tit" data-v-1aa5f304=""></div>
		              <div className="sub-tit" data-v-1aa5f304="">With more ways to unlock exciting perks, this is your all access
		                pass to exclusive rewards.</div>
		            </div>
		            <div className="container-right" data-v-1aa5f304="">
		              <div className="container-right-content" data-v-1aa5f304="">
		                <div className="join-button" data-v-fae5bece="" data-v-1aa5f304-s=""
		                  style={{backgroundColor: theme_color, color: font_color}}>Join Now</div>
		                <div className="sign-button" data-v-fae5bece="" data-v-1aa5f304-s=""> Already have an account? <a
		                    className="a-link" data-v-fae5bece="" data-v-1aa5f304-s="">Sign in<i className="iconfont iconright-arrow-2"
		                      data-v-fae5bece="" data-v-1aa5f304-s=""></i></a></div>
		              </div>
		            </div>
		          </div>
		        </div>
		        <div className="card-item-container" data-v-1aa5f304="" data-v-fae5bece="">
		          <div className="container-title" data-v-1aa5f304="">0 Points</div>
		          <div className="container-list" data-v-1aa5f304="">
		            <div className="container-left" data-v-1aa5f304="">
		              <div className="icon" data-v-1aa5f304=""><img
		                  src="data:image/png;base64,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"
											data-v-1aa5f304="" /></div>
		            </div>
		            <div className="container-center" data-v-1aa5f304="">
		              <div className="tit" data-v-1aa5f304=""></div>
		              <div className="sub-tit" data-v-1aa5f304="">Ways to earn</div>
		            </div>
		            <div className="container-right" data-v-1aa5f304="">
		              <div className="container-right-content" data-v-1aa5f304="">
		                <i className="iconfont iconright-arrow-2" data-v-fae5bece="" data-v-1aa5f304-s=""
		                  style={{fontSize: '8px'}}></i>
		              </div>
		            </div>
		          </div>
		          <div className="container-list" data-v-1aa5f304="">
		            <div className="container-left" data-v-1aa5f304="">
		              <div className="icon" data-v-1aa5f304=""><img
		                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAD20lEQVRYR+2YS2hUVxjHf5kYjVjFF4pjFsaYqIhEjdq6cGfbhUJLrDWL4hPFF0FFR0RLKq1SUTdtSlFEIV0Uoi4UZtPSulC0liK68IEPfEQkuYnGxhqYaHPlP5wbjuO9k7mTDMkiZzNzzznf9/3P9zrfd/Lo5yOvn+MjU4D5wHpgNTADSACXgSPAnxkcsgDYDHwFTAVeAReAw8CVdPSZABwCnAU+9WHkAjXAt2mEDAfiwEKfPf8b4EeD6DMBeBCIWQzuAxI6zpr7DvjaR8hI4DdgnlnTge4Bo4ExZk4g5wNX/UB2B7AQaAGGAa+BL4BzwCCjub0W0/2A/S1wvwNzzZ5/gUrjEjJ5rXEbLf8CrMgGoE7+tyE8DSxLYbIHkPa8IZ/aabQjzc0xC63AJ8A/1t6hwHNASpBWS7MBuAC4ZAiDTrkbOGAxl2bkb+VpwGlJVnhhrPMImJQNwBHGxDLJf8BHwA0fRjuAQz7zco+PgWs+a7uA7828gvDzMACVCqYAAia/qjDEErgdeOnDTGlkkTWvgNgHXPfZK9eR5r0Y+MEE0x3grr0/NUhmAictQH6HyvWc8uIa4KYE2QAnGycelWsEGfCXpWS1xzbAX4EqQyxVnzKpJQN+XVuWWGnlOPAkBPFgYDlQYmjqgJU2QOUpBYX8qxh4FoK5t/VnYIP5UAb4KySP8cADQCmoWZeBDVBOrSGnnhWScW8BFJ/b5r4WnogfQKWE2X0I8BYwzcjPGwCYhSUCNdhp0s5DYGMWjEWyBVhsaLcZfwrLStE/EXiji8I2sRLj9LDccrg/GQs2QFUbuhNVXfT1aAeUU8+nXnVKkkvNHSqgKs1/DIFWVbeXAZRon2ZIu9UoRvK+Ac6YfBjYk6h+U8HZCEzIUIi2ZZuoA+UFVdQDAFOs0rsadBzng46OjmgkEonYgsrLy2uam5uTBUdlZWVVbW2tXy1ok7REo1FVLr0D0HXdAsdxVFyu1f9U34zFYtTVKTYgHo9TUeHVuYFerPv2j2g0+mFnZ6c6xfd8PpQPNjY2qkFSo+Q7sgCY5FNWVkZbW5v+9higemIVtv0TYFNTU6vruko/AwA9DYTywQENhggS9SN64NHvWE/dudCg67qUlJTQ3q76IHl3q9TqGkEm1nuM9yKlTqteFLkAWF9fT3V1tQfoYuozXRDATcBPhkrJVJ1WR3FxcWl+fr4eM32H4zhePqOoqIjCwvSVWyKRoKGhwea1DlDB2q0GBUIlz2dBYHIwr9ezLwGvu0yKSPc+KJAq/VeZLitQcz0Aq7JePcgJ4BigtuOd0d0DZg9k9w5pvwf4Fvz9aziuDDelAAAAAElFTkSuQmCC"
											data-v-1aa5f304="" /></div>
		            </div>
		            <div className="container-center" data-v-1aa5f304="">
		              <div className="tit" data-v-1aa5f304=""></div>
		              <div className="sub-tit" data-v-1aa5f304="">Ways to redeem</div>
		            </div>
		            <div className="container-right" data-v-1aa5f304="">
		              <div className="container-right-content" data-v-1aa5f304="">
		                <i className="iconfont iconright-arrow-2" data-v-fae5bece="" data-v-1aa5f304-s=""
		                  style={{fontSize: '8px'}}></i>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		      <div className="Footer" data-v-40ab164b="" data-v-7ba5bd90="" data-v-5e5ab372-s="">
		        <div data-v-40ab164b=""><img className="icon-icon-block" src={require('../../static/widget-logo.png')} data-v-40ab164b="" /> Reward With Shopaghetti</div>
		      </div>
		  </div> 

					<div className='shopaghetti-btn-container'>
	          <div className="shopahetti-pop-btn shopahetti-animation" style={this.buttonStyle()}>
	            {this.button()}
	          </div>
	        </div>
			</div>
    )
  }
}
export default Preview
